import React, { useState } from "react";
import NonPhysicalWitnessManager from "./managerSafeGuardingForms/non-physical-witness-manager";
import NonPhysicalBehaviorManager from "./managerSafeGuardingForms/non-physical-behavioural-manager";
import NonPhysicalStrategiesManager from "./managerSafeGuardingForms/non-physical-strategy-manager";
import NonPhysicalDetailManager from "./managerSafeGuardingForms/non-physical-detail-manager";
import AfterIncidentManager from "./managerSafeGuardingForms/after-incident-manager";
import AntecedentBehaviourManager from "./managerSafeGuardingForms/antecedent-behaviour-manager";
import NonPhysicalChallengeManager from "./managerSafeGuardingForms/non-physical-challenge-manager";
import NonPhysicalIncidentManager from "./managerSafeGuardingForms/non-physical-incident-manager";

const ManagerSafeGuarding = ({ task, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0); // Step index;

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  // Rendering forms based on step
  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return <NonPhysicalWitnessManager witnessData={task?.nonPhysicalWitnessInfo} nextStep={nextStep} />;
      case 1:
        return (
          <NonPhysicalBehaviorManager
            behaviourData={task?.nonPhysicalBehaviouralInfo}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );
      case 2:
        return (
          <NonPhysicalStrategiesManager
            stragyData={task?.nonPhysicalStrategyInfo}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );
      case 3:
        return (
          <NonPhysicalDetailManager detailData={task?.nonPhysicalDetailInfo} nextStep={nextStep} prevStep={prevStep} />
        );
      case 4:
        return <AfterIncidentManager incidentData={task?.afterIncidentInfo} nextStep={nextStep} prevStep={prevStep} />;
      case 5:
        return (
          <AntecedentBehaviourManager
            antecentData={task?.antecedentBehaviourInfo}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );
      case 6:
        return (
          <NonPhysicalChallengeManager
            challengeData={task?.nonPhysicalChallengeInfo}
            temperature={task?.temperature}
            whoWasAround={task?.whoWasAround}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );
      case 7:
        return (
          <NonPhysicalIncidentManager
            physicaldata={task?.nonPhysicalIncidentInfo}
            incidentCategory={task?.incidentCategory}
            prevStep={prevStep}
            handleSubmit={onClose}
            gender={task?.gender}
            uploadedImages={task?.uploadedImages}
          />
        );
      default:
        return null;
    }
  };

  return <div>{renderForm()}</div>;
};

export default ManagerSafeGuarding;
